import { ErrorWrapper } from './util'

import { OdooService } from './odoo.service'

const MODEL = 'x_scorebook'
// const DOMAIN = { }
// const REQUIRED_FIELDS = ['id']
// const BASIC_FIELDS = ['display_name', 'parent_id', 'is_company']
const BASIC_FIELDS = []
// const OPTS = { limit: 20, order: 'id desc' }

export class ScorebookService extends OdooService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  static get entity () {
    return 'fields'
  }

  static async search (domain) {
    try {
      return await this.kwSearch(MODEL, domain, BASIC_FIELDS)
    } catch (error) {
      console.log(error)
    }
  }

  static async read (ids, fields = []) {
    try {
      return await this.kwRead(MODEL, ids, [...BASIC_FIELDS, ...fields])
    } catch (error) {
      console.log(error)
    }
  }

  static async searchRead (domain, fields = [], opts = {}) {
    try {
      return await this.kwSearchRead(MODEL, domain, fields, opts)
    } catch (error) {
      console.log(error)
    }
  }

  static async list (domain, fields = [], opts = {}) {
    this.recordIds = await this.kwSearch(MODEL, domain, fields, opts)
    const ret = []
    for (let i = 0; i < this.recordIds.length; i++) {
      try {
        const retTmp = (await this.kwRead(MODEL, this.recordIds[i]))[0]
        ret.push(retTmp)
      } catch (error) {
      }
    }
    return ret
  }

  static async create (data) {
    try {
      return await this.kwCreate(MODEL, data)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async delete (id) {
    try {
      return await this.kwDelete(MODEL, id)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async update (id, data) {
    try {
      // console.log(data)
      return await this.kwUpdate(MODEL, id, data)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async execute (method, params) {
    try {
      console.log(method, params)
      return await this.kwExecute(MODEL, method, params)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static decodeScore (record) {
    const score = JSON.parse(record.x_score.replaceAll("'", '"')) // JSON.parse(record.x_score)
    if (record.x_homeworks !== undefined) { score.tareas = record.x_homeworks }
    if (record.x_attendance !== undefined) { score.faltas = record.x_attendance }
    if (record.x_record_comment1_id !== undefined) { score.com_1 = record.x_record_comment1_id[0] }
    if (record.x_record_comment2_id !== undefined) { score.com_2 = record.x_record_comment2_id[0] }
    if (record.x_record_comment_string1 !== undefined) { score.x_record_comment_string1 = record.x_record_comment_string1 }
    if (record.x_record_comment_string2 !== undefined) { score.x_record_comment_string2 = record.x_record_comment_string2 }
    score.id = record.id
    return score
  }

  static countCertainDays (days, d0, d1) {
    var ndays = 1 + Math.round((d1 - d0) / (24 * 3600 * 1000))
    var sum = function (a, b) {
      return a + Math.floor((ndays + ((d0.getDay() + 6 - b) % 7)) / 7)
    }
    return days.reduce(sum, 0)
  }

  static encodeScore (record, schedule = [], teacherNotes = {}, period = {}, scoreTypes = []) {
    const score = { x_score: {}, x_avg: 0 }
    let sum = 0
    // let count = 0
    const keys = Object.keys(record)
    for (let i = 0; i < keys.length; i++) {
      if (keys[i] !== 'tareas' & keys[i] !== 'faltas' & keys[i] !== 'com_1' & keys[i] !== 'com_2' & keys[i] !== 'id' & keys[i] !== 'x_record_comment_string1' & keys[i] !== 'x_record_comment_string2') {
        // count++
        if (record[keys[i]] !== '') {
          sum = sum + parseFloat(record[keys[i]])
          score.x_score[keys[i]] = parseFloat(record[keys[i]])
        }
      }
    }
    if (scoreTypes.length > 0) {
      score.x_avg = parseFloat(sum / scoreTypes.length).toFixed(2)
    }
    score.x_score = JSON.stringify(score.x_score)
    score.x_score = score.x_score.replaceAll('\\"', "'")
    // console.log(JSON.parse(score.score))
    if (record.id) {
      score.id = record.id
    }
    if (period.x_type === 'exam') {

    } else {
      if (record.tareas) {
        score.x_homeworks = record.tareas
        score.x_homework_percentage = parseInt((score.x_homeworks * 100) / teacherNotes.x_homework_count)
        if (Number.isNaN(score.x_attendance_percentage)) { score.x_attendance_percentage = 0 }
      }
      if (record.faltas !== '') {
        score.x_attendance = record.faltas
        if (schedule[0] !== undefined) {
          const days = []
          for (var i = 0; i < schedule.length; i++) {
            if (schedule[i].x_day_of_week === 'monday') {
              days.push(1)
            } else if (schedule[i].x_day_of_week === 'tuesday') {
              days.push(2)
            } else if (schedule[i].x_day_of_week === 'wednesday') {
              days.push(3)
            } else if (schedule[i].x_day_of_week === 'thursday') {
              days.push(4)
            } else if (schedule[i].x_day_of_week === 'friday') {
              days.push(5)
            }
          }
          const classDays = this.countCertainDays(
            days,
            new Date(period.x_start_date),
            new Date(period.x_end_date)
          )
          let asist = 100
          asist = parseInt(((classDays - score.x_attendance) * asist) / classDays)
          if (Number.isNaN(asist)) { asist = 100 }
          score.x_attendance_percentage = asist
        }
      }

      if (record.com_1) {
        score.x_record_comment1_id = record.com_1
      }
      if (record.com_2) {
        score.x_record_comment2_id = record.com_2
      }
    }
    score.id = record.id
    return score
  }
}
